import React from 'react';
import { tns } from 'tiny-slider/src/tiny-slider';
import ProductSearch from './ProductSearch';
import ProductTypeResult from '../Search/ResultTypes/ProductTypeResult';

export default class ProductList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            category: props.category,
            results: null,
            resultCount: 0,
            perPage: props.perPage,
            page: 1,
            sort: props.sort,
            featured: props.featured,
            sale: props.sale,
            includeOldIds: props.includeOldIds,
            excludeOldIds: props.excludeOldIds,
            includeIds: props.includeIds,
            excludeIds: props.excludeIds,
            analytics: props.analytics,
            modifier: props.modifier,
            hideContent: props.hideContent
        };
        this.sliderRef = React.createRef();
    }

    async componentDidMount() {
        await this.handleSearch();
    }

    setUpSliders = () => {
        const slider = tns({
            container: this.sliderRef.current,
            loop: true,
            items: 4,
            nav: false,
            controls: true,
            responsive: {
                0: {
                    items: 1,
                },
                678: {
                    items: 2,
                },
                1024: {
                    items: 3,
                },
                1240: {
                    items: 4,
                },
            },
        });

        slider.refresh();
    }

    handleSearch = async () => {
        const {
            category,
            sort,
            perPage,
            page,
            featured,
            sale,
            includeOldIds,
            excludeOldIds,
            includeIds,
            excludeIds,
        } = this.state;
        const search = new ProductSearch(
            category,
            perPage,
            page,
            sort,
            featured,
            sale,
            includeOldIds,
            excludeOldIds,
            includeIds,
            excludeIds
        );
        const { responses } = await search.getResults();
        const resultCount = responses[0].hits.total.value;

        let state = {
            results: responses[0].hits.hits,
            resultCount,
            resultCountShort: resultCount > 500 ? '500+' : resultCount,
        };

        this.setState(state);

        if (resultCount > 1) {
            this.setUpSliders();
        }
    };

    render() {
        const { results, analytics, modifier, hideContent } = this.state;

        return (
            <div ref={this.sliderRef}>
                {results && results.map(item => {
                    return <ProductTypeResult
                        key={item._source.id}
                        item={item._source}
                        analytics={analytics}
                        modifier={modifier}
                        hideContent={hideContent}
                    />;
                })}
            </div>
        );
        
    }
}
